import { useMemo, useRef, useState, useEffect } from 'react'

//* Style
import LandingPartnersStyle from './style'
import 'swiper/css'
import 'swiper/css/navigation'

//* Components
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'
import Text from 'components/common/Text'
import Container from 'components/common/Container'
import Image from 'components/common/Image'
import Icon from 'components/common/Icon'

const LandingPartners = ({ title, slides, first }) => {
	//! State
	const [isArrowsVisible, setIsArrowsVisible] = useState(true)

	//! Refs
	const prevButton = useRef()
	const nextButton = useRef()

	const storePartnersSlide = useMemo(() => {
		return slides.map((slide, index) => {
			//! Choosing icon by index
			const getIconName = (index + 1) % 2 === 0 ? 'decorative-2' : (index + 1) % 3 === 0 ? 'decorative-3' : 'decorative-1'

			return (
				<SwiperSlide key={index}>
					<Image objectFit={'cover'} src={slide.image.url} alt={slide.image.alt} className={'slide-image'} />
					<Text className={'h5 font-ping-bolder'} text={slide.fullName} />
					<Text className={'pS font-ping-bold role'} text={slide.role} />
					<Text className={'p font-helvetica'} text={slide.info} />
					<Icon name={getIconName} className={'decorative-icon'} />
				</SwiperSlide>
			)
		})
	}, [slides])

	useEffect(() => {
		if (
			prevButton.current?.[0].className.includes('swiper-button-disabled') &&
			nextButton.current?.[0].className.includes('swiper-button-disabled')
		) {
			setIsArrowsVisible(false)
		}
	}, [prevButton.current, nextButton.current])

	return (
		<LandingPartnersStyle>
			<Container first={first} section>
				<div className='title-and-arrows-wrap'>
					<Text tag={'h3'} className={'font-ping-bolder partners-title'} text={title || 'ourPartners'} />
					{isArrowsVisible && (
						<div className='arrows-wrap'>
							<Icon ref={prevButton} name={'arrow'} className='slider-button slider-prev-button' />
							<Icon ref={nextButton} name={'arrow'} className='slider-button slider-next-button' />
						</div>
					)}
				</div>
				<Swiper
					navigation={{
						prevEl: '.slider-prev-button',
						nextEl: '.slider-next-button',
					}}
					modules={[Navigation]}
					spaceBetween={40}
					breakpoints={{
						2560: {
							slidesPerView: 3,
							spaceBetween: 40,
						},
						1920: {
							slidesPerView: 3,
							spaceBetween: 32,
						},
						1510: {
							slidesPerView: 3,
							spaceBetween: 24,
						},
						1440: {
							slidesPerView: 3,
							spaceBetween: 24,
						},
						1280: {
							slidesPerView: 3,
							spaceBetween: 24,
						},
						1024: {
							slidesPerView: 3,
							spaceBetween: 20,
						},
						768: {
							slidesPerView: 2,
							spaceBetween: 20,
						},
						414: {
							slidesPerView: 1,
							spaceBetween: 0,
						},
					}}
				>
					{storePartnersSlide}
				</Swiper>
			</Container>
		</LandingPartnersStyle>
	)
}

export default LandingPartners
